import React, { useEffect } from 'react'
// Import Swiper Use
import { useSwiperSlide } from 'swiper/react';
import { gsap } from 'gsap'


function TextSplit({data, tag, ...props}) {
    const swiperSlide = useSwiperSlide();
    // Split Text
    const chars = data.split('');
    
     // GSAP Split text
     useEffect(() => {  
        gsap.set('.text-1, .text-2, .text-3', {y: 100, opacity: 0});   
        gsap.to('.text-1', {y:0, opacity: 1, ease:"ease.in", duration: 1})
        gsap.to('.text-2', {y:0, opacity: 1, ease:"ease.out", duration: 1, delay:0.2 })
        gsap.to('.text-3', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.4 })
    }, [swiperSlide.isActive]);

  return (
    <>
        {tag == 'h1' && (
            <h1 {...props}>
                <span className='text-1 relative inline-block'>{chars[0]}</span>
                <span className='text-2 relative inline-block'>{chars[1]}</span>
                <span className='text-3 relative inline-block'>{chars[2]}</span>
                <span className='text-1 relative inline-block'>{chars[3]}</span>
                <span className='text-2 relative inline-block'>{chars[4]}</span>
                <span className='text-3 relative inline-block'>{chars[5]}</span>
                <span className='text-1 relative inline-block'>{chars[6]}</span>
            </h1>
        )}
    </>
  )
}

export default TextSplit